class SuggestionsRefManager {
  static _refs = [];

  static add(name, ref) {
    const exists = this._refs.some((item) => item.name === name);

    if (!exists) {
      this._refs = this._refs.concat({
        name,
        ref,
      });
    }
  }

  static remove(name) {
    this._refs = this._refs.filter((item) => item.name === name);
  }

  static flush() {
    this._refs = [];
  }

  static all() {
    return this._refs;
  }
}

export default SuggestionsRefManager;
